import {USER_SIGNED_IN} from '../constants/actions'
export function userSignedIn(payload) {
  return { type: USER_SIGNED_IN, payload };
}
